/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Product_Type_MocInputs */

const vi_shop_product_type_moc = /** @type {(inputs: Shop_Product_Type_MocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mộc`)
};

/**

* @param {Shop_Product_Type_MocInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_product_type_moc = /** @type {((inputs?: Shop_Product_Type_MocInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Product_Type_MocInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_product_type_moc(inputs)
});